import { Link } from "react-router-dom";
import { ArrowRight, Users, Landmark } from "lucide-react";

const AUDIENCES = [
  {
    href: "/federal-employees",
    icon: Users,
    eyebrow: "For Individuals & Households",
    title: "Federal Employees & Recent Retirees",
    body: "Specialized retirement and tax planning for current federal workers, recent retirees, and Foreign Service Officers navigating the unique mechanics of TSP, FERS, CSRS, the Special Retirement Supplement, and Social Security with WEP/GPO offsets. Through every season of public service — steady or uncertain — careful planning is what keeps a federal career on course.",
    cta: "Explore the Federal-Employee Practice",
  },
  {
    href: "/government",
    icon: Landmark,
    eyebrow: "For Public Agencies",
    title: "Federal & State Contracting",
    body: "Budget operations, compliance and audit liaison, Working Capital Fund management, and financial-analysis services for federal and state agencies. SAM.gov registered. MBE and LSBRP certified. Past performance with State, DOL, HHS, and others.",
    cta: "View Past Performance & Capability",
  },
];

export default function ClientsPage() {
  return (
    <div data-testid="page-clients" className="bg-[#F9F8F6]">
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-16">
        <div className="text-xs uppercase tracking-[0.3em] text-[#8E6A2B] mb-6">— Our Clients</div>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-[#0F292F] font-light tracking-tight max-w-4xl leading-[1.05]">
          Two audiences.<br />
          One <span className="italic text-[#8E6A2B]">steady</span> hand.
        </h1>
        <p className="mt-8 text-lg text-[#52525B] max-w-2xl leading-relaxed">
          H. Elliot Associates serves two distinct audiences — individual federal employees
          and the public agencies that employ them. Both come to the same firm for the same
          reason: experienced, calm, careful work.
        </p>
      </section>

      <div className="hairline max-w-7xl mx-auto" />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid md:grid-cols-2 gap-px bg-black/10 border border-black/10">
          {AUDIENCES.map((a) => (
            <Link
              key={a.href}
              to={a.href}
              data-testid={`clients-card-${a.href.replace("/", "")}`}
              className="bg-white p-10 md:p-14 hover:bg-[#F3F1EC] transition-colors duration-500 group block"
            >
              <a.icon size={36} strokeWidth={1.2} className="text-[#8E6A2B] mb-8" />
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#8E6A2B] mb-3">
                {a.eyebrow}
              </div>
              <h2 className="font-serif text-3xl md:text-4xl text-[#0F292F] mb-5 leading-tight">
                {a.title}
              </h2>
              <p className="text-[#52525B] leading-relaxed mb-8">{a.body}</p>
              <div className="text-xs uppercase tracking-[0.2em] text-[#0F292F] inline-flex items-center gap-2 group-hover:text-[#8E6A2B]">
                {a.cta} <ArrowRight size={14} />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
